export default "﻿<div>\n    <h2>NoteMaterial</h2>\n    <div data-dojo-attach-point=\"listContainer\">\n\n    </div>\n</div>\n"